import React, { useState } from 'react';

const CTA = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      window.location.href = `mailto:200okstudios@gmail.com?subject=Waitlist Signup&body=I am interested in joining the waitlist! Please add my email: ${encodeURIComponent(email)}`;
    }
  };

  return (
    <section className="cta" id="waitlist">
      <div className="cta__glow"></div>

      <div className="cta__content reveal">
        <div className="cta__code">{'// GET EARLY ACCESS'}</div>
        <h2 className="cta__title">Be in the first wave.</h2>
        <p className="cta__description">
          We're opening access to a limited group before public launch. Early
          users shape the product, get priority onboarding, and lock in
          early-access pricing.
        </p>

        {!submitted ? (
          <form className="cta__form" onSubmit={handleSubmit}>
            <div className="cta__input-group">
              <input
                type="email"
                className="cta__input"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="btn btn--cta-primary">
                Reserve My Spot
                <span className="material-symbols-outlined">
                  arrow_forward
                </span>
              </button>
            </div>
            <p className="cta__hint">
              We'll only email you when it matters. No noise.
            </p>
            <p className="cta__trust">
              🔒 Your information is never shared or sold.
            </p>
          </form>
        ) : (
          <div className="cta__success">
            <span className="material-symbols-outlined">check_circle</span>
            <p>You're in! We'll be in touch when it matters.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default CTA;
